"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.success = exports.routing = exports.provider = exports.pending = exports.initializing = exports.error = exports.confirmationPage = exports.cancelingAppointment = exports.canceledPreviously = exports.cancelPage = exports.cancelFinished = exports.cancelExpiredPage = exports.cancelError = exports.cancelDisabledPage = exports.cancelDisabled = exports.appointmentCancel = exports.appointment = void 0;
const appointment = exports.appointment = '@state/APPOINTMENT';
const appointmentCancel = exports.appointmentCancel = '@state/APPOINTMENT_CANCEL';
const cancelDisabled = exports.cancelDisabled = '@state/CANCEL_DISABLED';
const cancelDisabledPage = exports.cancelDisabledPage = '@state/CANCEL_DISABLED_PAGE';
const canceledPreviously = exports.canceledPreviously = '@state/CANCELED_PREVIOUSLY';
const cancelError = exports.cancelError = '@state/CANCEL_ERROR';
const cancelExpiredPage = exports.cancelExpiredPage = '@state/CANCEL_EXPIRED_PAGE';
const cancelFinished = exports.cancelFinished = '@state/CANCEL_FINISHED';
const cancelingAppointment = exports.cancelingAppointment = '@state/CANCELING_APPOINTMENT';
const cancelPage = exports.cancelPage = '@state/CANCEL_PAGE';
const confirmationPage = exports.confirmationPage = '@state/CONFIRMATION_PAGE';
const error = exports.error = '@state/ERROR';
const initializing = exports.initializing = '@state/INITIALIZING';
const pending = exports.pending = '@state/PENDING';
const provider = exports.provider = '@state/PROVIDER';
const success = exports.success = '@state/SUCCESS';
const routing = exports.routing = '@state/ROUTING';